import React from "react";
import ReactSwitch from "react-switch";
import { getValue } from "../../utils";
import ImageInput from "../common/ImageInput";

const DynamicForm = ({
  object,
  layout,
  base_url,
  modifier,
  questions,
  saveAction,
  hideButtons,
  handleCancel,
}) => {
  const handleSubmit = (event) => {
    event.preventDefault();
    if (typeof saveAction === "function") {
      saveAction(object);
    }
  };

  const renderForm = () => {
    if (Array.isArray(questions) && object !== null) {
      let questionsRender = [...questions];
      questionsRender = questionsRender
        .filter((question) => {
          if (question.precondition) {
            if (!question.precondition(object)) {
              return null;
            }
          }
          return question;
        })
        .filter((question) => question !== null);
      if (layout === "inline") {
        return questionsRender.map((question) => (
          <div key={question.id} className="row align-items-center mb-3">
            {question.type !== "boolean" && (
              <div className="col-12 col-md-6">
                <label htmlFor={question.id} className="form-label mb-0">
                  {question.label}
                </label>
              </div>
            )}
            <div className="col-12 col-md-6">{renderInput(question)}</div>
          </div>
        ));
      }
      return questionsRender.map((question) => (
        <div
          key={question.id}
          className={question.className ? question.className : "col-12 mb-3"}
        >
          {question.type !== "boolean" && (
            <label htmlFor={question.id} className="form-label mb-0">
              {question.label}
            </label>
          )}
          {renderInput(question)}
        </div>
      ));
    }
  };

  const renderOptions = (options) => {
    return options.map(({ value, label }) => (
      <option key={value} value={value}>
        {label}
      </option>
    ));
  };

  const renderInput = (question) => {
    const { id, type, label, required, options } = question;
    if (type === "select") {
      return (
        <select
          value={getValue(object, id)}
          className="form-control"
          onChange={(e) => modifier(id, e.target.value)}
        >
          {renderOptions(options)}
        </select>
      );
    }
    if (type === "boolean") {
      return (
        <label className="d-flex align-items-center">
          <ReactSwitch
            checked={getValue(object, id) === true}
            className="me-2"
            onChange={(checked) => modifier(id, checked)}
          />
          {label}
        </label>
      );
    }
    if (type === "textarea") {
      return (
        <textarea
          rows="4"
          id={id}
          name={id}
          required={required}
          value={getValue(object, id)}
          className="form-control mb-3"
          onChange={(event) => modifier(id, event.target.value)}
        />
      );
    }
    if (type === "file") {
      return (
        <ImageInput
          base_url={base_url}
          value={getValue(object, id)}
          modifier={(file) => modifier(id, file)}
        />
      );
    }
    return (
      <input
        id={id}
        name={id}
        type={type}
        required={required}
        className="form-control"
        value={type !== "file" ? getValue(object, id) : ""}
        onChange={(event) => modifier(id, event.target.value)}
      />
    );
  };

  const renderButtons = () => {
    if (!hideButtons) {
      return (
        <div className="row mt-3">
          <div className="col-6 text-end">
            <button
              type="button"
              onClick={handleCancel}
              className="btn w-100 text-muted px-0"
            >
              Cancel
            </button>
          </div>
          <div className="col-6">
            <button type="submit" className="btn w-100 btn-primary">
              Save
            </button>
          </div>
        </div>
      );
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {renderForm()}
      {renderButtons()}
    </form>
  );
};

export default DynamicForm;
